module.exports = __webpack_public_path__ + "static/img/wr1077bb.1b7c912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wr1077bb.jpg
// module id = ECyl
// module chunks = 0